import React, { useState, useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { apiFetch } from "../../api.js";
import Layout from "../../components/Layout.js";

const ReasonMasterDetailsDesign = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const allowAlphabets = (value) => value.replace(/[^a-zA-Z ]/g, "");
  const [Reason, setReason] = useState("");
  const [errors, setErrors] = useState({});
  const [isEditMode, setIsEditMode] = useState(false);
  const [ipAddress, setIpAddress] = useState("");
  const [userId, setUserId] = useState("");
  const [serverIp] = useState(window.location.hostname);
  const storedUserInfo = JSON.parse(sessionStorage.getItem("userinfo")) || {};
  const [unqid, setUnqid] = useState("");

  const inputStyle = (error) => ({
    padding: "12px 15px",
    height: "45px",
    marginTop: "5px",
    borderRadius: "6px",
    border: error ? "2px solid red" : "1px solid #ccc",
    width: "100%",
    fontSize: "15px",
    boxSizing: "border-box",
    backgroundColor: "#fff",
  });

  const buttonContainerStyle = {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    gap: "12px",
    flexWrap: "wrap", // mobile friendly
    width: "100%",
    marginTop: "20px",
    position: "relative",
    zIndex: 10,
  };

  const buttonStyle = (bgColor) => ({
    minWidth: "120px", // ✅ same width everywhere
    height: "42px",
    padding: "0 20px",
    backgroundColor: bgColor,
    color: "#fff",
    border: "none",
    borderRadius: "6px",
    cursor: "pointer",
    fontWeight: "bold",
    whiteSpace: "nowrap", // ✅ no text breaking
  });
  useEffect(() => {
    const storedUserInfo = JSON.parse(sessionStorage.getItem("userinfo")) || {};
    setUserId(storedUserInfo.userId || "");
  }, []);

  useEffect(() => {
    apiFetch("/api/get-ip")
      .then((res) => res.json())
      .then((data) => setIpAddress(data.ip))
      .catch(() => setIpAddress("0.0.0.0"));
  }, []);

  //------------------Exit Working-----------------------
  const handleExit = () => {
    navigate("/ReasonMasterGrid");
  };
  //---------------------SAVE WORKING---------------
  const handleSave = async () => {
    let validationErrors = {};
    if (!Reason.trim()) {
      validationErrors.Reason = true;
    }
    if (Object.keys(validationErrors).length > 0) {
      setErrors(validationErrors);
      return;
    }
    setErrors({});
    const payload = {
      what: "insert",
      prefix: "",
      sp_501: new Date().toISOString(),
      sp_502: "",
      sp_503: userId,
      sp_504: ipAddress,
      sp_505: serverIp,
      sp_506: "",
      sp_507: Reason.trim(),
    };
    try {
      const response = await apiFetch(
        "/api/reason-master",
        { method: "POST", body: JSON.stringify(payload) },
      );
      const data = await response.json();
      if (data.err === "0") {
        alert("Saved successfully");
        setReason("");
        setUnqid(data.unqid);
      } else {
        alert(data.msg || "Error saving data");
      }
      navigate("/ReasonMasterGrid");
    } catch (error) {
      console.error("Save Error:", error);
      alert("Server error. Please try again.");
    }
  };
  //-------------------Edit Working--------------
  useEffect(() => {
    if (location.state?.unqid) {
      setIsEditMode(true);
      setUnqid(location.state.unqid);
      fetchEditData(location.state.unqid);
    }
  }, [location.state]);

  const fetchEditData = async (id) => {
    try {
      const response = await apiFetch(
        "/api/reason-master/edit",
        { method: "POST", body: JSON.stringify({ what: "edit", sp_502: id }) },
      );
      const data = await response.json();
      if (data.err === "0") {
        setReason(data.data.reason || "");
      }
    } catch (error) {
      console.error("Edit fetch error:", error);
    }
  };
  //-------------------Update Working--------------
  const handleUpdate = async () => {
    let validationErrors = {};
    if (!Reason.trim()) {
      validationErrors.Reason = true;
    }
    if (Object.keys(validationErrors).length > 0) {
      setErrors(validationErrors);
      return;
    }
    try {
      const response = await apiFetch(
        "/api/reason-master/update",
        {
          method: "POST",
          body: JSON.stringify({
            sp_502: unqid,
            sp_503: userId,
            sp_504: ipAddress,
            sp_505: serverIp,
            sp_507: Reason.trim(),
          }),
        },
      );
      const data = await response.json();
      if (data.err === "0") {
        alert("Updated successfully");
        navigate("/ReasonMasterGrid");
      } else {
        alert(data.msg || "Update failed");
      }
    } catch (error) {
      console.error("Update Error:", error);
      alert("Server error. Please try again.");
    }
  };

  return (
    <Layout>
      <div className="page-container">
        <div className="container">
          <div className="header">Reason Master</div>

          {/* Form Section */}
          <div className="form-row">
            <div className="form-column">
              <label>Reason</label>
              <input
                type="text"
                value={Reason}
                onChange={(e) => setReason(allowAlphabets(e.target.value))}
                style={inputStyle(errors.Reason)}
              />
            </div>
            <div className="form-column"></div>
          </div>

          {/* Buttons */}
          <div style={buttonContainerStyle}>
            {!isEditMode && (
              <button style={buttonStyle("#4caf50")} onClick={handleSave}>
                Save
              </button>
            )}
            {isEditMode && (
              <button style={buttonStyle("#2e20abff")} onClick={handleUpdate}>
                Update
              </button>
            )}

            <button style={buttonStyle("#ab2025")} onClick={handleExit}>
              Exit
            </button>
          </div>
        </div>
      </div>

      <style>
        {`
       .page-container {
  width: 100%;
  min-height: 100vh;
  background: #f4f6f8;
  display: flex;
  justify-content: center;
  padding: 12px;
  box-sizing: border-box;
}

.container {
  width: 100%;
  max-width: 100%;
  background: #fff;
  border-radius: 8px;
  padding: 18px;
  box-shadow: 0 4px 8px rgba(0,0,0,0.08);
  box-sizing: border-box;
}

/* ===== HEADER ===== */
.header {
  text-align: center;
  font-size: 1.6rem;
  font-weight: 700;
  padding: 14px;
  background: linear-gradient(90deg, #8B1E3F, #8B1E3F);
  color: #fff;
  border-radius: 6px;
  margin-bottom: 18px;
}

/* ===== FORM GRID ===== */
.form-row {
  display: grid;
  grid-template-columns: repeat(4, minmax(0, 1fr));
  gap: 15px;
  margin-bottom: 18px;
}

.form-column {
  display: flex;
  flex-direction: column;
}

.form-column label {
  font-size: 13px;
  font-weight: 600;
  margin-bottom: 6px;
  color: #333;
}

/* ===== INPUT UNIFORM ===== */
.form-column input {
  height: 40px;
  padding: 8px 12px;
  border: 1px solid #ccc;
  border-radius: 6px;
  background: #fff;
  font-size: 14px;
  box-sizing: border-box;
}

.form-column input:focus {
  outline: none;
  border-color: #8B1E3F;
  box-shadow: 0 0 5px rgba(139,30,63,0.25);
}

/* ===== BUTTONS ===== */
.button-container {
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 12px;
  margin-top: 20px;
  flex-wrap: wrap;
}

.button-container button {
  width: 120px;
  padding: 10px;
  border-radius: 6px;
  font-weight: 600;
  cursor: pointer;
  border: none;
}

/* ===== RESPONSIVE ===== */

/* Tablet */
@media (max-width: 992px) {
  .form-row {
    grid-template-columns: repeat(2, 1fr);
  }
}

/* Mobile */
@media (max-width: 480px) {
  .form-row {
    grid-template-columns: 1fr;
  }
}

        `}
      </style>
    </Layout>
  );
};

export default ReasonMasterDetailsDesign;
